import {
  ANIMATING_IMAGE_ERROR,
  ANIMATING_IMAGE_SUCCESS,
  ANIMATING_IMAGE_TITLE,
  CAMPAIGN_GENERATED_ERROR,
  CAMPAIGN_GENERATED_SUCCESS,
  EDITING_IMAGE_ERROR,
  EDITING_IMAGE_SUCCESS,
  EDITING_IMAGE_TITLE,
  GENERATING_CAMPAIGN,
  GENERATING_CREATIVE_ERROR,
  GENERATING_CREATIVE_SUCCESS,
  GENERATING_CREATIVE_TITLE,
  GENERATING_VIDEO_MESSAGE,
  GENERATING_CUSTOM_REPORT_MESSAGE,
  GENERATING_CUSTOM_REPORT_SUCCESS,
  GENERATING_CUSTOM_REPORT_ERROR,
  ANALYZING_IMAGE_LAYERS_MESSAGE,
  ANALYZING_IMAGE_LAYERS_SUCCESS,
  ANALYZING_IMAGE_LAYERS_ERROR,
  ANALYZING_CREATIVE_TEMPLATE_MESSAGE,
  ANALYZING_CREATIVE_TEMPLATE_SUCCESS,
  ANALYZING_CREATIVE_TEMPLATE_ERROR,
  PRODUCING_CREATIVE_TEMPLATE_MESSAGE,
  PRODUCING_CREATIVE_TEMPLATE_SUCCESS,
  PRODUCING_CREATIVE_TEMPLATE_ERROR,
  RESIZING_IMAGE_ERROR,
  RESIZING_IMAGE_SUCCESS,
  RESIZING_IMAGE_TITLE,
  RESIZING_IMAGES_BATCH_MESSAGE,
  BULK_CAMPAIGNS_ALERT_ANALYSIS_ERROR,
  BULK_CAMPAIGNS_ALERT_ANALYSIS_SUCCESS,
  BULK_CAMPAIGNS_ALERT_ANALYZING,
  BULK_CAMPAIGNS_ALERT_GENERATING,
  BULK_CAMPAIGNS_ALERT_GENERATION_ERROR,
  BULK_CAMPAIGNS_ALERT_GENERATION_SUCCESS,
} from "../i18n/keysTranslations";
import { CREATIVE_JOB_TYPES } from "./errors";

export const CREATIVE_ALERT_TYPE = {
  generatingCreative: "generatingCreative",
  campaign: "campaign",
  generatingCustomReport: "generatingCustomReport",
  analyzingImageLayers: "analyzingImageLayers",
  analyzingCreativeTemplate: "analyzingCreativeTemplate",
  producingCreativeTemplate: "producingCreativeTemplate",
  imageAnimation: "imageAnimation",
  bulkCampaigns: "bulkCampaigns",
};

export const BULK_CAMPAIGNS_JOB_KIND = {
  analysis: "analysis",
  generation: "generation",
};

export const CREATIVE_ALERT_MODAL_TYPE = {
  createWithIA: "createWithIA",
  gallery: "gallery",
  imageEdit: "imageEdit",
  imageEditBatch: "imageEditBatch",
  customReport: "customReport",
  imageEditLayers: "imageEditLayers",
  bulkCampaigns: "bulkCampaigns",
};

export const CREATIVE_ALERT_PLACEHOLDER_KIND = {
  none: "none",
  resize: "resize",
  edit: "edit",
  animate: "animate",
  batch: "batch",
};

const DEFAULT_CREATIVE_JOB_ALERT_CONFIG = {
  alertType: CREATIVE_ALERT_TYPE.generatingCreative,
  messageKeys: {
    loading: GENERATING_CREATIVE_TITLE,
    success: GENERATING_CREATIVE_SUCCESS,
    error: GENERATING_CREATIVE_ERROR,
  },
  modalType: CREATIVE_ALERT_MODAL_TYPE.createWithIA,
  mediaType: "image",
  persistFrom: "none",
  placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.none,
};

export const CREATIVE_JOB_ALERT_CONFIG = {
  [CREATIVE_JOB_TYPES.generateImages]: {
    alertType: CREATIVE_ALERT_TYPE.generatingCreative,
    messageKeys: {
      loading: GENERATING_CREATIVE_TITLE,
      success: GENERATING_CREATIVE_SUCCESS,
      error: GENERATING_CREATIVE_ERROR,
    },
    modalType: CREATIVE_ALERT_MODAL_TYPE.createWithIA,
    mediaType: "image",
    persistFrom: "none",
    placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.none,
  },
  [CREATIVE_JOB_TYPES.generateVideo]: {
    alertType: CREATIVE_ALERT_TYPE.generatingCreative,
    messageKeys: {
      loading: GENERATING_VIDEO_MESSAGE,
      success: GENERATING_CREATIVE_SUCCESS,
      error: GENERATING_CREATIVE_ERROR,
    },
    modalType: CREATIVE_ALERT_MODAL_TYPE.createWithIA,
    mediaType: "video",
    persistFrom: "none",
    placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.none,
  },
  [CREATIVE_JOB_TYPES.editImage]: {
    alertType: CREATIVE_ALERT_TYPE.generatingCreative,
    messageKeys: {
      loading: EDITING_IMAGE_TITLE,
      success: EDITING_IMAGE_SUCCESS,
      error: EDITING_IMAGE_ERROR,
    },
    modalType: CREATIVE_ALERT_MODAL_TYPE.imageEdit,
    mediaType: "image",
    persistFrom: "none",
    placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.edit,
  },
  [CREATIVE_JOB_TYPES.editImagesBatch]: {
    alertType: CREATIVE_ALERT_TYPE.generatingCreative,
    messageKeys: {
      loading: EDITING_IMAGE_TITLE,
      success: EDITING_IMAGE_SUCCESS,
      error: EDITING_IMAGE_ERROR,
    },
    modalType: CREATIVE_ALERT_MODAL_TYPE.imageEditBatch,
    mediaType: "image",
    persistFrom: "none",
    placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.batch,
  },
  [CREATIVE_JOB_TYPES.resizeImage]: {
    alertType: CREATIVE_ALERT_TYPE.generatingCreative,
    messageKeys: {
      loading: RESIZING_IMAGE_TITLE,
      success: RESIZING_IMAGE_SUCCESS,
      error: RESIZING_IMAGE_ERROR,
    },
    modalType: CREATIVE_ALERT_MODAL_TYPE.gallery,
    mediaType: "image",
    persistFrom: "upload",
    placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.resize,
  },
  [CREATIVE_JOB_TYPES.resizeImagesBatch]: {
    alertType: CREATIVE_ALERT_TYPE.generatingCreative,
    messageKeys: {
      loading: RESIZING_IMAGES_BATCH_MESSAGE,
      success: RESIZING_IMAGE_SUCCESS,
      error: RESIZING_IMAGE_ERROR,
    },
    modalType: CREATIVE_ALERT_MODAL_TYPE.gallery,
    mediaType: "image",
    persistFrom: "upload",
    placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.resize,
  },
  [CREATIVE_JOB_TYPES.animateImage]: {
    alertType: CREATIVE_ALERT_TYPE.generatingCreative,
    messageKeys: {
      loading: ANIMATING_IMAGE_TITLE,
      success: ANIMATING_IMAGE_SUCCESS,
      error: ANIMATING_IMAGE_ERROR,
    },
    modalType: CREATIVE_ALERT_MODAL_TYPE.gallery,
    mediaType: "video",
    persistFrom: "upload",
    placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.animate,
  },
  [CREATIVE_JOB_TYPES.generateRecommendedSettingsPlatform]: {
    alertType: CREATIVE_ALERT_TYPE.campaign,
    messageKeys: {
      loading: GENERATING_CAMPAIGN,
      success: CAMPAIGN_GENERATED_SUCCESS,
      error: CAMPAIGN_GENERATED_ERROR,
    },
    modalType: null,
    mediaType: "ai",
    persistFrom: "none",
    placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.none,
  },
  [CREATIVE_JOB_TYPES.generateCustomReport]: {
    alertType: CREATIVE_ALERT_TYPE.generatingCustomReport,
    messageKeys: {
      loading: GENERATING_CUSTOM_REPORT_MESSAGE,
      success: GENERATING_CUSTOM_REPORT_SUCCESS,
      error: GENERATING_CUSTOM_REPORT_ERROR,
    },
    modalType: CREATIVE_ALERT_MODAL_TYPE.customReport,
    mediaType: "ai",
    persistFrom: "none",
    placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.none,
  },
  [CREATIVE_JOB_TYPES.analyzeImageLayers]: {
    alertType: CREATIVE_ALERT_TYPE.analyzingImageLayers,
    messageKeys: {
      loading: ANALYZING_IMAGE_LAYERS_MESSAGE,
      success: ANALYZING_IMAGE_LAYERS_SUCCESS,
      error: ANALYZING_IMAGE_LAYERS_ERROR,
    },
    modalType: CREATIVE_ALERT_MODAL_TYPE.imageEditLayers,
    mediaType: "image",
    persistFrom: "none",
    placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.none,
  },
  [CREATIVE_JOB_TYPES.analyzeCreativeTemplate]: {
    alertType: CREATIVE_ALERT_TYPE.analyzingCreativeTemplate,
    messageKeys: {
      loading: ANALYZING_CREATIVE_TEMPLATE_MESSAGE,
      success: ANALYZING_CREATIVE_TEMPLATE_SUCCESS,
      error: ANALYZING_CREATIVE_TEMPLATE_ERROR,
    },
    modalType: null,
    mediaType: "image",
    persistFrom: "none",
    placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.none,
  },
  [CREATIVE_JOB_TYPES.produceCreativeTemplate]: {
    alertType: CREATIVE_ALERT_TYPE.producingCreativeTemplate,
    messageKeys: {
      loading: PRODUCING_CREATIVE_TEMPLATE_MESSAGE,
      success: PRODUCING_CREATIVE_TEMPLATE_SUCCESS,
      error: PRODUCING_CREATIVE_TEMPLATE_ERROR,
    },
    modalType: null,
    mediaType: "image",
    persistFrom: "none",
    placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.none,
  },
  [CREATIVE_JOB_TYPES.analyzeBulkCampaigns]: {
    alertType: CREATIVE_ALERT_TYPE.bulkCampaigns,
    messageKeys: {
      loading: BULK_CAMPAIGNS_ALERT_ANALYZING,
      success: BULK_CAMPAIGNS_ALERT_ANALYSIS_SUCCESS,
      error: BULK_CAMPAIGNS_ALERT_ANALYSIS_ERROR,
    },
    modalType: CREATIVE_ALERT_MODAL_TYPE.bulkCampaigns,
    mediaType: "ai",
    persistFrom: "none",
    placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.none,
  },
  [CREATIVE_JOB_TYPES.generateBulkCampaigns]: {
    alertType: CREATIVE_ALERT_TYPE.bulkCampaigns,
    messageKeys: {
      loading: BULK_CAMPAIGNS_ALERT_GENERATING,
      success: BULK_CAMPAIGNS_ALERT_GENERATION_SUCCESS,
      error: BULK_CAMPAIGNS_ALERT_GENERATION_ERROR,
    },
    modalType: CREATIVE_ALERT_MODAL_TYPE.bulkCampaigns,
    mediaType: "ai",
    persistFrom: "none",
    placeholderKind: CREATIVE_ALERT_PLACEHOLDER_KIND.none,
  },
};

export const getCreativeJobAlertConfig = (jobType) =>
  CREATIVE_JOB_ALERT_CONFIG[jobType] || DEFAULT_CREATIVE_JOB_ALERT_CONFIG;

export const isCreativeJobAlertEnabled = (jobType) =>
  Boolean(CREATIVE_JOB_ALERT_CONFIG[jobType]);
